export const RoutesPaths = {
  LANDING: "/",
  TERMSCONDITIONS: '/terms-conditions',
  PRIVACYPOLICY: '/privacy-policy',
  ACCOUNTCLOSE: '/account-close',
  SUCCESSPAGE: '/transaction',
};
